import React, { useEffect, useState } from "react";
import axios from "axios";
import {
 Card,
 CardContent,
 CardActions,
 TextField,
 Button,
 Typography,
} from "@mui/material";

const FullPaymentSetting = () => {
 const [fullPaymentDiscount, setFullPaymentDiscount] = useState(null);
 const [percent, setPercent] = useState("");
 const [isEditing, setIsEditing] = useState(false);
 const [error, setError] = useState("");

 useEffect(() => {
  // Fetch the current full payment discount when the component mounts
  axios
   .get(
    "https://app-api.carexpert.org.in/api/admin/setting/full-payment-discount",
   )
   .then((response) => {
    if (response.data) {
     setFullPaymentDiscount(response.data.data.percent);
     setPercent(response.data.data.percent);
    }
   })
   .catch((error) => {
    console.error("Error fetching the full payment discount:", error);
    setError("Failed to fetch the discount setting");
   });
 }, []);

 const handleUpdateFullPaymentDiscount = () => {
  if (percent < 0 || percent > 100) {
   setError("Discount must be between 0 and 100");
   return;
  }

  // Call the API to update the full payment discount
  axios
   .put(
    "https://app-api.carexpert.org.in/api/admin/setting/full-payment-discount",
    {
     percent,
    },
   )
   .then((response) => {
    setFullPaymentDiscount(response.data.data.percent);
    setIsEditing(false);
    setError(""); // Clear any previous errors
    alert("Full payment discount updated successfully");
   })
   .catch((error) => {
    console.error("Error updating the full payment discount:", error);
    setError("Failed to update the discount");
   });
 };

 return (
  <Card
   sx={{
    maxWidth: 400,
    margin: "20px auto",
    padding: "20px",
    borderRadius: "8px",
    boxShadow: 3,
   }}
  >
   <CardContent>
    <Typography variant="h5" sx={{ marginBottom: "10px", fontWeight: 500 }}>
     Full Payment Discount
    </Typography>
    {error && (
     <Typography variant="body2" sx={{ color: "red", marginBottom: "10px" }}>
      {error}
     </Typography>
    )}
    {isEditing ? (
     <TextField
      label="Full Payment Discount (%)"
      type="number"
      value={percent}
      onChange={(e) => setPercent(e.target.value)}
      variant="outlined"
      fullWidth
      sx={{ marginBottom: "20px" }}
     />
    ) : (
     <Typography variant="body1" sx={{ marginBottom: "20px" }}>
      Current Full Payment Discount:{" "}
      {fullPaymentDiscount !== null ? `${fullPaymentDiscount}%` : "Not Set"}
     </Typography>
    )}
   </CardContent>
   <CardActions>
    {isEditing ? (
     <>
      <Button
       variant="contained"
       color="primary"
       onClick={handleUpdateFullPaymentDiscount}
      >
       Save
      </Button>
      <Button
       variant="outlined"
       color="secondary"
       onClick={() => setIsEditing(false)}
       sx={{ marginLeft: "10px" }}
      >
       Cancel
      </Button>
     </>
    ) : (
     <Button
      variant="outlined"
      color="primary"
      onClick={() => setIsEditing(true)}
     >
      Edit
     </Button>
    )}
   </CardActions>
  </Card>
 );
};

export default FullPaymentSetting;
